<template>

    <div class="card shadow">
        <div class="card-header">
            <form id="selectForm" method="get">
                <div class="row form-inline ">
                    <div class="col-sm-2 col-md-6 col-xl-12 form-group d-flex align-items-middle ">
                        <select :disabled="!activateInputs" v-model="team_id" class="form-control me-3" name="team_id"
                            id="team_id">
                            <option :value="0" selected>{{ $trans.get("__JSON__.All teams") }}</option>
                            <option v-for="team in teams" :key="team.id" :value="team.id">
                                {{ team.name }}
                            </option>
                        </select>
                        <select :disabled="!activateInputs" v-model="employer_id" class="form-control me-3"
                            name="employer_id" id="employer_id">
                            <option :value="0" selected>{{ $trans.get("__JSON__.All employers") }}</option>
                            <option v-for="employer in employers" :key="employer.id" :value="employer.id">
                                {{ employer.name }}
                            </option>
                        </select>
                        <select :disabled="!activateInputs" v-model="location_id" class="form-control me-3"
                            name="location_id" id="location_id">
                            <option :value="0" selected>{{ $trans.get("__JSON__.All locations") }}</option>
                            <option v-for="location in locations" :key="location.id" :value="location.id">
                                {{ location.name }}
                            </option>
                        </select>
                        <select :disabled="!activateInputs" v-model="division_id" class="form-control me-3"
                            name="division_id" id="division_id">
                            <option :value="0" selected>{{ $trans.get("__JSON__.All divisions") }}</option>
                            <option v-for="division in divisions" :key="division.id" :value="division.id">
                                {{ division.name }}
                            </option>
                        </select>
                        <select :disabled="!activateInputs" v-model="date_filter_option_id" class="form-control me-3"
                            name="date_filter_options" id="date_filter_options">
                            <option v-for="(name, key)  in date_filter_options" :key="key" :value="name.toLowerCase()">
                                {{ $trans.get("__JSON__." + name) }}
                            </option>
                        </select>
                        <!-- <div class="col-2">
                            <div>Dashlets rendering</div>
                            <div class="progress" role="progressbar" style="height: 20px;">
                                <div class="progress-bar progress-bar-striped bg-info" role="progressbar"
                                    :style="renderedDashletProgressbar"></div>
                            </div>
                        </div> -->
                    </div>
                </div>

                <div class="row form-inline mt-3">
                    <div class="col-10 form-group d-flex align-items-middle">
                        <div class="form-group me-3 ">
                            <span
                                class="me-3 material-symbols-outlined icon bg-soft-primary text-primary rounded-circle">calendar_month
                            </span>
                            <label class="me-3" for="date">{{ $trans.get("__JSON__.Day") }}</label>
                            <input :disabled="!activateInputs" v-model="to_Date" type="date" id="toDate" name="toDate"
                                autocomplete="off" class="form-control me-3" v-tooltip
                                :title="$trans.get('__JSON__.Enddate of selected timeframe')" />
                        </div>

                        <!-- Button trigger modal -->
                        <button :disabled="!activateInputs" type="button" class="btn btn-primary" v-tooltip
                            :title="$trans.get('__JSON__.select or deselect dashlets')"
                            @click="buttonSelectableDashletsModalAnzeigenClick">
                            <span class="material-symbols-outlined"> dashboard_customize </span></button>
                        <!-- Modal -->
                        <!-- <Teleport to="body"> -->
                        <div id="selectableDashletsModal" class="modal" >
                            <div v-if="can('dashlets-hr-list | dashlets-operations-list | dashlets-executive-list')"
                                class="modal-dialog modal-lg" style="z-index: 1000;">
                                <div class="modal-content">
                                    <div class="modal-header">
                                        <h5 class="modal-title">{{ $trans.get("__JSON__.Dashboard Selection") }}
                                        </h5>
                                        <button @click.prevent="closeSelectModal" class="btn-close" data-bs-dismiss="modal"
                                            aria-label="Close"></button>
                                    </div>
                                    <div class="modal-body">
                                        <!-- {{ selectedDashletIds }} {{ sortingDashlets }} -->
                                        <ul id="list-selectableDashlets" class="list-group">
                                            <!-- {{ userDashlets }} -->
                                            <li draggable="TRUE" v-for="dashlet_type in sortedDashlets"
                                                :key="'dt-' + dashlet_type.id"
                                                class="list-group-item list-group-item-action">
                                                <input class="" type="checkbox" @click="selectDashlet(dashlet_type)"
                                                    :value="dashlet_type.name"
                                                    :checked="selectedDashlets.includes(dashlet_type.id) ? 'checked' : false">
                                                {{ $trans.get("__JSON__." + dashlet_type.name) }}
                                                <form class="inline float-end" @keypress.enter.prevent>
                                                    <input class="" style="width: 50px" :value="dashlet_type.user_sort"
                                                        @change="setUserSort(dashlet_type.id, $event.target.value)" />
                                                </form>
                                            </li>
                                        </ul>
                                    </div>
                                    <div class="modal-footer">
                                        <button @click.prevent="closeSelectModal" class="btn btn-secondary">Abbrechen</button>
                                        <button @click.prevent="buttonSpeichernClick"
                                            class="btn btn-primary">Speichern</button>
                                    </div>
                                </div>
                            </div>
                            <div v-if="!can('dashlets-hr-list | dashlets-operations-list | dashlets-executive-list')"
                                class="modal-dialog modal-m">
                                <div class="modal-content">
                                    <div class="modal-header row text-danger">
                                        <span class="material-symbols-outlined col-3 text-end"
                                            style="font-size: xx-large !important;">
                                            warning
                                        </span>
                                        <h3 class="col-9">
                                            {{ $trans.get("__JSON__.Permission Error") }}
                                        </h3>
                                    </div>
                                    <div class="modal-body">
                                        <p>{{ $trans.get("__JSON__.Not allowed to view dashlets. Missing permission.Please contact your Admin.")}}</p>
                                    </div>
                                    <div class="modal-footer">
                                        <button @click.prevent="closeSelectModal" class="btn btn-secondary">Abbrechen</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="!activateInputs" style="position:fixed; top: 0px; left: 0px; width: 100%; height: 100%; z-index: 100; background: black; opacity: 25%;">
                            <span class="spinner" style="position:fixed; top: 50%; left: 50%; z-index: 150; width: 4rem; height: 4rem;  border-width: 10px !important; opacity: 100%;"></span>
                        </div>
                        
                        <!-- </Teleport> -->
                    </div>
                </div>
            </form>
        </div>
    </div>

    <div class="card shadow mt-2">
        <div class="card-body">
            <div class="row" v-if="dashlets.length > 0">
                <div class="col-sm-12 col-md-6 col-lg-6 col-xl-4" v-for="selectedDashlet in userDashlets"
                    :key="'sd-' + selectedDashlet.pivot.sort_order" :id="'sd-' + selectedDashlet.pivot.sort_order"
                    :index="selectedDashlet.pivot.sort_order">
                    <div class="card shadow mb-3">
                        <Dashlet :team_id="team_id" :employer_id="employer_id" :location_id="location_id"
                            :division_id="division_id" :date_filter_option_id="date_filter_option_id" :to_Date="to_Date"
                            :dashlet_type="selectedDashlet.name" :userDashlet="selectedDashlet" :employers="employers"
                            :locations="locations" :teams="teams" :divisions="divisions" :thresholdable="selectedDashlet.thresholdable"
                            @rendering-completed="increaseRenderedCount">
                        </Dashlet>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style>
#execute_query:hover {
    background-color: #AC3864;
}

.material-symbols-outlined {
    font-variation-settings:
        'FILL' 0,
        'wght' 600,
        'GRAD' 0,
        'opsz' 48
}
</style>


<script>

import getLocations from "../../composables/getLocations"
import getTeams from "../../composables/getTeams"
import getDivisions from "../../composables/getDivisions"
import getEmployers from "../../composables/getEmployers"
import userDashletsHandling from "../../composables/UserDashlets"
import getDashlets from "../../composables/getDashlets"


import Dashlet from "../../components/dashboard/Dashlet"


import { Suspense, ref } from 'vue'



export default {
    name: "Dashboard",
    setup() {
        const { userDashlets, userDashlets_error, loadUserDashlets, userDashletsPut_error, syncUserDashlets } = userDashletsHandling();
        loadUserDashlets();
        const { locations, locations_error, loadLocations } = getLocations();
        loadLocations();
        const { teams, teams_error, loadTeams } = getTeams();
        loadTeams();
        const { divisions, divisions_error, loadDivisions } = getDivisions();
        loadDivisions();
        const { employers, employers_error, loadEmployers } = getEmployers();
        loadEmployers();
        const { dashlets, dashlets_error, loadDashlets } = getDashlets();
        loadDashlets();

        return {
            locations, locations_error, loadLocations,
            teams, teams_error, loadTeams,
            divisions, divisions_error, loadDivisions,
            employers, employers_error, loadEmployers,
            userDashlets, userDashlets_error, loadUserDashlets, userDashletsPut_error, syncUserDashlets,
            dashlets, dashlets_error, loadDashlets

        };
    },
    components: {
        Dashlet
    },
    data() {
        return {
            location_id: 0,
            team_id: 0,
            employer_id: 0,
            division_id: 0,
            calendarweek: 0,
            Day: 0,
            Week: 0,
            month: 0,
            Year: 0,
            to_Date: null,
            date_filter_options: {
                day: "Day",
                week: "Week",
                month: "month",
                year: "Year"
            },
            date_filter_option_id: 'day',
            day_filter: false,
            week_filter: false,
            month_filter: false,
            year_filter: false,
            selectedDashlets: [],
            // numberOfDashlets: 0,
            numberOfRenderedDashlets: 0,
            saveNumberOfRenderedDashlets: 0,
        }
    },
    watch: {
        userDashlets(newValue, oldValue) {
            if (this.userDashlets.length > 0 && this.dashlets.length > 0) {
                this.transferSorting();
            }
        },
        dashlets(newValue, oldValue) {
            if (this.userDashlets.length > 0 && this.dashlets.length > 0) {
                this.transferSorting();
            }
        },
        date_filter_option_id(newValue, oldValue) {
            if (newValue != oldValue) {
                this.numberOfRenderedDashlets = 0;
            }
        },
        location_id(newValue, oldValue) {
            if (newValue != oldValue) {
                this.numberOfRenderedDashlets = 0;
            }
        },
        team_id(newValue, oldValue) {
            if (newValue != oldValue) {
                this.numberOfRenderedDashlets = 0;
            }
        },
        employer_id(newValue, oldValue) {
            if (newValue != oldValue) {
                this.numberOfRenderedDashlets = 0;
            }
        },
        division_id(newValue, oldValue) {
            if (newValue != oldValue) {
                this.numberOfRenderedDashlets = 0;
            }
        },
        to_Date(newValue, oldValue) {
            if (newValue != oldValue) {
                this.numberOfRenderedDashlets = 0;
            }
            $(".tooltip").css("display", "none");
        }
    },
    computed: {
        years() {
            const year = new Date().getFullYear()
            return Array.from({ length: year - 2019 }, (value, index) => 2020 + index)
        },
        sortedDashlets() {
            return this.dashlets.sort(this.compareSortOrder);
        },
        numberOfDashlets() {
            return this.userDashlets.length;
        },
        activateInputs() {
            if (this.numberOfRenderedDashlets == this.numberOfDashlets) {
                return true;
            }
            return false;
        },
        renderedDashletProgressbar() {
            return ('width: ' + this.numberOfRenderedDashlets * 100 / this.numberOfDashlets + '%;');
        }
    },
    created() {
        this.to_Date = this.formatDate(new Date());
    },
    methods: {
        formatDate(date) {
            var d = new Date(date),
                month = "" + (d.getMonth() + 1),
                day = "" + d.getDate(),
                year = d.getFullYear();

            if (month.length < 2) month = "0" + month;
            if (day.length < 2) day = "0" + day;

            return [year, month, day].join("-");
        },
        transferSorting() {
            // SortOrder übernehmen
            this.dashlets.forEach((element) => {
                const userDashlet = this.userDashlets.find(dashlet => element.id == dashlet.id);
                element.user_sort = null;
                if (userDashlet) {
                    element.user_sort = userDashlet.pivot.sort_order;
                }
            });
            // SelectedDashlets füllen
            this.selectedDashlets = [];
            this.userDashlets.forEach(
                (userDashlet) => {
                    this.selectedDashlets.push(userDashlet.id);
                }
            );

        },
        buttonSelectableDashletsModalAnzeigenClick() {
            this.selectedDashletIds = [];
            this.sortingDashlets = [];
            this.saveNumberOfRenderedDashlets = this.numberOfRenderedDashlets;
            this.numberOfRenderedDashlets = 0;
            var sortNumber = 0;
            if (this.userDashlets) {
                for (var userDashlet of this.userDashlets) {
                    this.selectedDashletIds.push(userDashlet.id);
                    this.sortingDashlets.push(userDashlet.pivot.sort_order);
                    sortNumber += 1;
                }
            }
            $('#selectableDashletsModal').modal({ backdrop: 'static', keyboard: false })
            $('#selectableDashletsModal').modal("show");
            $(".tooltip").css("display", "none");
        },
        compareSortOrder(a, b) {
            if (a.user_sort < b.user_sort) {
                return -1;
            }
            if (a.user_sort > b.user_sort) {
                return 1;
            }

            if (a.sort_order < b.sort_order) {
                return -1;
            }
            if (a.sort_order > b.sort_order) {
                return 1;
            }
            return 0;
        },
        setUserSort(dashletId, sortNumber) {
            var dashlet = this.dashlets.find((element) => element.id == dashletId);
            dashlet.user_sort = sortNumber;
        },
        buttonSpeichernClick() {
            if (this.selectedDashlets.length < this.userDashlets.length) {
                this.numberOfRenderedDashlets = this.selectedDashlets.length;
            }
            if (this.selectedDashlets.length > this.userDashlets.length) {
                this.numberOfRenderedDashlets = this.userDashlets.length;
            }
            $('#selectableDashletsModal').modal("hide");
            const newDashlets = [];
            this.selectedDashlets.forEach((dashletId) => {
                newDashlets.push(this.dashlets.find((dashlet) => dashlet.id == dashletId));
            });
            this.syncUserDashlets(newDashlets);
            this.loadUserDashlets();

            $(".tooltip").css("display", "none");
        },
        selectDashlet(dashlet_type) {
            if (this.selectedDashlets.includes(dashlet_type.id)) {
                this.selectedDashlets = this.selectedDashlets.filter(id => id != dashlet_type.id);
            } else {
                this.selectedDashlets.push(dashlet_type.id);
            }
        },
        increaseRenderedCount(n) {
            this.numberOfRenderedDashlets += n;
        },
        closeSelectModal() {
            console.log("hier");
            this.numberOfRenderedDashlets = this.saveNumberOfRenderedDashlets;
            $('#selectableDashletsModal').modal("hide");
            $(".tooltip").css("display", "none");
        }
    }
}
</script>
